// extracted by css-extract-rspack-plugin
export default {"cart":"Cart-module__cart--EcZo4"};